module.exports = __webpack_public_path__ + "static/img/jinjichang_1.9426bb12.png";